import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { withdrawRequest } from "../../redux/slice/passbookSlice";
import { IoClose } from "react-icons/io5";
import { message } from "antd";

const Redeem = ({ reward, redeemtoggle }) => {
  const dispatch = useDispatch();
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paypalEmail, setPaypalEmail] = useState("");
  const [razorpayId, setRazorpayId] = useState("");
  const [upiId, setUpiId] = useState("");
  const [bankDetails, setBankDetails] = useState({
    accountName: "",
    accountNumber: "",
    bankName: "",
    ifscCode: "",
  });

  const handleBankChange = (e) => {
    setBankDetails({ ...bankDetails, [e.target.name]: e.target.value });
  };

  const onFinish = (e) => {
    e.preventDefault();

    if (!paymentMethod) {
      message.error("Please select a payment method");
      return;
    }

    let paymentDetails = {};

    switch (paymentMethod) {
      case "paypal":
        if (!paypalEmail) { message.error("Please enter PayPal email"); return; }
        paymentDetails = { email: paypalEmail };
        break;
      case "razorpay":
        if (!razorpayId) { message.error("Please enter Razorpay ID"); return; }
        paymentDetails = { razorpayId };
        break;
      case "upi":
        if (!upiId) { message.error("Please enter UPI ID"); return; }
        paymentDetails = { upiId };
        break;
      case "bank_transfer":
        if (!bankDetails.accountName || !bankDetails.accountNumber || !bankDetails.bankName || !bankDetails.ifscCode) {
          message.error("Please fill all bank details");
          return;
        }
        paymentDetails = { ...bankDetails };
        break;
      default:
        break;
    }

    const withdrawDetails = {
      amount: reward.points,
      currency: "INR",
      paymentMethod,
      paymentDetails,
    };

    dispatch(withdrawRequest(withdrawDetails));
    redeemtoggle();
  };

  return (
    <div className="redeem-info-card">
      <div className="card-shadow" onClick={redeemtoggle}></div>
      <div className="login-card">
        <span className="close-btn" onClick={redeemtoggle}>
          <IoClose />
        </span>

        <h5 className="mb-1">Withdraw Request</h5>
        <p className="text-muted small mb-3">
          Redeeming <strong>{reward.title}</strong> — {reward.rewardPrice}
        </p>
        <hr />

        <form onSubmit={onFinish}>
          <div className="mb-3 text-start">
            <label className="form-label fw-semibold">Payment Method</label>
            <select
              className="form-select"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              required
            >
              <option value="">-- Select Payment Method --</option>
              <option value="paypal">PayPal</option>
              <option value="razorpay">Razorpay</option>
              <option value="upi">UPI</option>
              <option value="bank_transfer">Bank Transfer</option>
            </select>
          </div>

          {paymentMethod === "paypal" && (
            <div className="mb-3 text-start">
              <label className="form-label fw-semibold">PayPal Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your PayPal email"
                value={paypalEmail}
                onChange={(e) => setPaypalEmail(e.target.value)}
                required
              />
            </div>
          )}

          {paymentMethod === "razorpay" && (
            <div className="mb-3 text-start">
              <label className="form-label fw-semibold">Razorpay ID / Linked Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Razorpay ID or email"
                value={razorpayId}
                onChange={(e) => setRazorpayId(e.target.value)}
                required
              />
            </div>
          )}

          {paymentMethod === "upi" && (
            <div className="mb-3 text-start">
              <label className="form-label fw-semibold">UPI ID</label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. username@upi"
                value={upiId}
                onChange={(e) => setUpiId(e.target.value)}
                required
              />
            </div>
          )}

          {paymentMethod === "bank_transfer" && (
            <>
              <div className="mb-3 text-start">
                <label className="form-label fw-semibold">Account Holder Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter account holder name"
                  name="accountName"
                  value={bankDetails.accountName}
                  onChange={handleBankChange}
                  required
                />
              </div>
              <div className="mb-3 text-start">
                <label className="form-label fw-semibold">Account Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter account number"
                  name="accountNumber"
                  value={bankDetails.accountNumber}
                  onChange={handleBankChange}
                  required
                />
              </div>
              <div className="mb-3 text-start">
                <label className="form-label fw-semibold">Bank Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter bank name"
                  name="bankName"
                  value={bankDetails.bankName}
                  onChange={handleBankChange}
                  required
                />
              </div>
              <div className="mb-3 text-start">
                <label className="form-label fw-semibold">IFSC Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter IFSC code"
                  name="ifscCode"
                  value={bankDetails.ifscCode}
                  onChange={handleBankChange}
                  required
                />
              </div>
            </>
          )}

          {paymentMethod && (
            <>
              <p className="text-muted small mt-3">
                Your payment will be processed within 7 working days.
              </p>
              <button type="submit" className="btn btn-primary w-100 mt-2">
                Submit Withdraw Request
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default Redeem;
